(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('InvoiceHeader', InvoiceHeader);

    InvoiceHeader.$inject = ['$resource', 'DateUtils'];

    function InvoiceHeader ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.salesOrderDate = DateUtils.convertLocalDateFromServer(data.salesOrderDate);
                        data.invoiceExpirationDate = DateUtils.convertLocalDateFromServer(data.invoiceExpirationDate);
                        data.dueDate = DateUtils.convertLocalDateFromServer(data.dueDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.salesOrderDate = DateUtils.convertLocalDateToServer(copy.salesOrderDate);
                    copy.invoiceExpirationDate = DateUtils.convertLocalDateToServer(copy.invoiceExpirationDate);
                    copy.dueDate = DateUtils.convertLocalDateToServer(copy.dueDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.salesOrderDate = DateUtils.convertLocalDateToServer(copy.salesOrderDate);
                    copy.invoiceExpirationDate = DateUtils.convertLocalDateToServer(copy.invoiceExpirationDate);
                    copy.dueDate = DateUtils.convertLocalDateToServer(copy.dueDate);
                    return angular.toJson(copy);
                }
            },
            'omniboxSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/invoice-headers/omniboxSearch'
            }
        });
    }
})();
